<template>
  <div class="settings">
    <div class="settings-wrap">
      <div class="settings-title">{{ $t('navSettings') }}</div>
      <div class="settings-content">
        <form @submit.prevent="submit" class="settings-form">
          <div class="settings-row disabled-row">
            <BaseInput :readonly="true" v-model="form.apiKey" :label="$t('apiKey')" />
          </div>
          <div class="settings-row disabled-row">
            <BaseInput :readonly="true" v-model="form.apiSecret" :label="$t('apiSecret')" />
          </div>
          <div class="settings-logo">
            <img src="../../assets/img/xpay-logo-new.png" alt="" />
          </div>
          <div class="settings-info">
            <p>
              {{ $t('walletLabel') }}
            </p>
            <span>{{ $t('walletLabel2') }}</span>
          </div>
          <div class="settings-row" v-if="walletTokens.length">
            <div class="settings-card__wrap" v-for="item in walletTokens" :key="item.id">
              <div class="settings-card" v-if="item.isDefault">
                <div class="settings-card__title">{{ $t('yourSavedCard') }}:</div>
                <div class="settings-card__item">*{{ item.last4 }}</div>
                <div class="settings-card__date">
                  {{ $t('dateAdded') }}: <strong>{{ formattedDate(item.createdAt) }}</strong>
                </div>
                <div class="settings-action" v-if="walletTokens">
                  <BaseButton
                    oval
                    :loading="deleteLoading"
                    :disabled="deleteLoading"
                    @click.prevent="deleteCard(item)"
                    >{{ $t('deleteCard') }}</BaseButton
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="settings-row" v-if="mountStripeElement && !walletTokens.length">
            <div class="settings-row__title">{{ $t('saveDebitCard') }}:</div>
            <card
              class="stripe-card"
              :stripe="$options.stripeApiKey"
              :options="stripeOptions"
              ref="settingsStripeCard"
              :hidePostalCode="true"
              @change="isComplete = $event.complete"
            />
          </div>
          <div class="settings-action" v-if="!walletTokens.length">
            <BaseButton oval :loading="loading" :disabled="payDisabled || loading">{{ $t('buttonSave') }}</BaseButton>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Card, createToken } from 'vue-stripe-elements-plus'
import moment from 'moment/moment'
const STRIPE_API_KEY = process.env.VUE_APP_STRIPE_API_KEY

export default {
  name: 'PaymentsTransactions',
  data () {
    return {
      deleteLoading: false,
      isComplete: false,
      form: {
        apiKey: null,
        apiSecret: null
      },
      subscription: {
        card_number: '',
        expires_end: '',
        cvv: ''
      },
      loading: false,
      name: '',
      number: false,
      expiry: false,
      cvc: false,
      submitting: false,
      errorResp: null,
      mountStripeElement: false,
      stripeOptions: {
        hidePostalCode: true,
        classes: {
          base: 'my-card-base-class',
          complete: 'my-card-complete-class',
          empty: 'my-card-empty-class',
          focus: 'my-card-focus-class',
          invalid: 'my-card-invalid-class',
          webkitAutofill: 'my-card-autofill-class'
        },
        style: {
          base: {
            fontSize: '16px',
            color: '#32325d',
            fontFamily: "'Montserrat', sans-serif",
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: 'rgba(0, 0, 0, 0.4)'
            },
            ':-webkit-autofill': {
              color: '#fce883'
            },
            '-webkit-autofill': {
              color: '#fce883'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      },
      cardError: false,
      cardErrorText: '',
      expiresError: false,
      expiresErrorText: '',
      cvvError: false
    }
  },
  components: {
    Card
  },
  stripeApiKey: STRIPE_API_KEY,
  computed: {
    ...mapGetters({
      balance: 'wallet/balance',
      transactions: 'wallet/transactions',
      affiliatesCount: 'affiliate/count',
      walletInfo: 'wallet/walletInfo',
      walletTokens: 'wallet/walletTokens',
      user: 'auth/user'
    }),
    payDisabled () {
      return !this.isComplete
    }
  },
  mounted () {
    this.mountStripeElement = true
    this.setInitialValues()
  },
  methods: {
    ...mapActions({
      createWalletCard: 'wallet/createWalletCard',
      createWalletToken: 'wallet/createWalletToken',
      deleteWalletToken: 'wallet/deleteWalletToken',
      getWalletTokens: 'wallet/getWalletTokens'
    }),
    setInitialValues () {
      this.form.apiKey = this.walletInfo.apiKey
      this.form.apiSecret = this.walletInfo.apiSecret
    },
    isPending (transaction) {
      return transaction.status === 'PENDING'
    },
    isWithdraw (transaction) {
      return ['Package purchase', 'Withdraw to Xpay'].includes(transaction.typeName)
    },
    showDetailTransaction () {
      this.$modal.show('transaction-detail')
    },
    formattedDate (date) {
      return moment.utc(date).local().format('MMMM. DD, YYYY, HH:mm:ss A')
    },
    async deleteCard (item) {
      try {
        this.deleteLoading = true
        await this.deleteWalletToken({ id: item.id })
        this.$modal.show('success')
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      } finally {
        this.deleteLoading = false
      }
    },
    async submit () {
      try {
        this.loading = true
        const data = {}
        const stripeResp = await createToken()
        if (stripeResp) {
          const {
            token: { id }
          } = stripeResp
          data.token = id
          data.holaId = this.user.id
          data.isDefault = true
        }
        await this.createWalletToken(data)
        this.$modal.show('success')
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  padding-right: 15px;
  max-height: 565px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 8px;
    position: absolute;
    background: rgba(17, 17, 17, 0.1);
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    position: absolute;
    z-index: -2;
  }
  &::-webkit-scrollbar-thumb {
    background: #00b764;
    border-radius: 5px;
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-logo {
    display: flex;
    justify-content: flex-end;
    width: 120px;
    margin-left: auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-info {
    margin-top: 60px;
    p {
      font-size: 14px;
      line-height: 1.3;
      color: #f7941d;
    }
    span {
      display: block;
      font-size: 13px;
      color: #fd0113;
      margin: 5px 0 20px;
    }
  }
  &-action {
    max-width: 350px;
    margin: 30px auto 0;
    width: 100%;
    button {
      width: 100%;
      padding: 15px 30px;
      background: #f7931d;
      height: 50px;
      &.button--disabled {
        opacity: 0.4;
      }
    }
  }
  &-row {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    &__title {
      text-align: left;
      font-size: 16px;
      line-height: 1.2;
      margin-bottom: 10px;
      width: 100%;
    }
    .form-container {
      width: 100%;
    }
    label {
      width: 100%;
    }
  }
  .stripe-row {
    .invalid-feedback {
      color: red;
      text-align: left;
      width: 100%;
      margin-top: 2px;
      font-size: 12px;
    }
    &:not(:first-child) {
      margin-top: 15px;
    }
    input {
      width: 100%;
      color: #3b3b3b;
      display: block;
      font-size: 16px;
      height: 40px;
      padding: 7px 1px;
      border-bottom: 1px solid #5a5a5a;
      background-color: rgba(255, 255, 255, 0);
    }
  }
  &-card {
    &__wrap {
      width: 100%;
    }
    &__title {
      width: 100%;
      text-align: left;
      font-size: 16px;
      line-height: 1.5;
    }
    &__item {
      margin: 10px 0;
      font-weight: bold;
      font-size: 17px;
    }
    &__date {
      text-align: left;
      font-size: 16px;
      line-height: 1.5;
    }
  }
  .disabled-row {
    input,
    label {
      pointer-events: none;
      user-select: none;
    }
    input {
      opacity: 0.8;
    }
  }
}
</style>
<style lang="scss">
.settings-row {
  .stripe-card {
    width: 100%;
  }
}
.settings {
  .multiselect__input,
  .multiselect__tags,
  .multiselect__single {
    background: transparent;
  }
}
.my-card-base-class {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}

.my-card-complete-class {
  border-color: #2ecc71;
}

.my-card-empty-class {
  border-color: #ccc;
}

.my-card-focus-class {
  box-shadow: 0 0 0 2px rgba(30, 144, 255, 0.2);
}

.my-card-invalid-class {
  border-color: #fa755a;
}
</style>
